import Vue from 'vue'
import VueRouter from 'vue-router'
import { getAuth } from 'firebase/auth'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Home from '../views/Jobs/Home.vue'
import Addjob from '../views/Jobs/Addjob.vue'
import UserProfile from '../views/UserProfile.vue'
import Activity from '../views/Activity/Activity.vue'
import ActivityJobs from '../views/Activity/Jobs/ActivityJobs.vue'
import ActivitySalesOrderTracker from '../views/Activity/SalesOrderTracker/ActivitySalesOrderTracker.vue'
import ViewJob from '../views/Jobs/ViewJob.vue'
import Functions from '../views/Functions.vue'
import Returns from '../views/Return/Returns.vue'
import AddReturns from '../views/Return/AddReturns.vue'
import EditReturns from '../views/Return/EditReturns.vue'
import PO from '../views/PO/PO.vue'
import AddPO from '../views/PO/AddPO.vue'
import EditPO from '../views/PO/EditPO.vue'
import AddDeliveries from '../views/Delivery/AddDeliveries.vue'
import EditDeliveries from '../views/Delivery/EditDeliveries.vue'
import Deliveries from '../views/Delivery/Deliveries.vue'
import AllReturns from '../views/Return/AllReturns.vue'
import AllJobs from '../views/Jobs/AllJobs.vue'
import AllDeliveries from '../views/Delivery/AllDeliveries.vue'
import AllPO from '../views/PO/AllPO.vue'
import AllReport from '../views/Report/AllReport.vue'
import AddFailedReport from '../views/FailedReports/AddFailedReport.vue'
import EditFailedReport from '../views/FailedReports/EditFailedReport.vue'
import ViewFailedReport from '../views/FailedReports/ViewFailedReport.vue'
import RequestLeave from '../views/RequestLeave.vue'
import ClockIn from '../views/ClockIn.vue'
import AdminSection from '../views/Admin/AdminSection.vue'
import AdminPasswordReset from '../views/Admin/AdminPasswordReset.vue'
import ReportBug from '../views/ReportBug.vue'
import EngineerVB from '@/views/Jobs/EngineerVB.vue'
import SalesVB from '@/views/Jobs/SalesVB.vue'
import TechVB from '@/views/Jobs/TechVB.vue'
import TechAddJob from '@/views/Jobs/TechAddJob.vue'
import AddSpares from '@/views/AwaitingSpares/AddSpares.vue'
import EditSpares from '@/views/AwaitingSpares/EditSpares.vue'
import AllSpares from '@/views/AwaitingSpares/AllSpares.vue'
import Spares from '@/views/AwaitingSpares/Spares.vue'
import AddQuote from '@/views/Quote/AddQuote.vue'
import EditQuote from '@/views/Quote/EditQuote.vue'
import AllQuote from '@/views/Quote/AllQuote.vue'
import Quote from '@/views/Quote/Quote.vue'
import AddSample from '@/views/Samples/AddSample.vue'
import EditSample from '@/views/Samples/EditSample.vue'
import AllSample from '@/views/Samples/AllSample.vue'
import Sample from '@/views/Samples/Sample.vue'
import AddSalesTracker from '@/views/SalesTracker/AddSalesTracker.vue'
import EditSalesTracker from '@/views/SalesTracker/EditSalesTracker.vue'
import AllSalesTracker from '@/views/SalesTracker/AllSalesTracker.vue'
import AddShipment from '@/views/Shipment/AddShipment.vue'
import EditShipment from '@/views/Shipment/EditShipment.vue'
import AllShipment from '@/views/Shipment/AllShipment.vue'
import EditSerialNumber from '@/views/SerialNumber/EditSerialNumber.vue'
import AllSerialNumber from '@/views/SerialNumber/AllSerialNumber.vue'
import AddSerialNumber from '@/views/SerialNumber/AddSerialNumber.vue'
import AllJobReports from '@/views/JobReports/AllJobReports.vue'
import AddJobReports from '@/views/JobReports/AddJobReports.vue'
import EditJobReports from '@/views/JobReports/EditJobReports.vue'
import OldJobs from '@/views/OldJobs/OldJobs.vue'
import AddOldJobs from '@/views/OldJobs/AddOldJobs.vue' 
import EditOldJobs from '@/views/OldJobs/EditOldJobs.vue'
import DropdownManager from '@/views/Admin/DropdownManager.vue'
import SharedServices from '@/views/SharedServices/SharedServices.vue'
// import InventoryView from '@/views/InventoryView.vue'
import AddQuotation from '@/views/CustomerQuotes/AddQuotation.vue'
import AllQuoted from '@/views/CustomerQuotes/AllQuoted.vue'
import EditQuotation from '@/views/CustomerQuotes/AddQuotation.vue'
// import QuotePortal from '@/views/CustomerQuotes/QuotePortal.vue'

Vue.use(VueRouter)

// Fix for navigation duplication errors
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch((err) => {
    if (VueRouter.isNavigationFailure(err)) {
      return err
    }
    return Promise.reject(err)
  })
}

const routes = [
  { path: '/', name: 'Login', component: Login, meta: { requiresAuth: false } },
  { path: '/login', name: 'LoginRedirect', component: Login, meta: { requiresAuth: false } },
  { path: '/register', name: 'Register', component: Register, meta: { requiresAuth: false } },
  
  // NEW: Quote Landing Page Route (Hidden behind domain check)
  { 
    path: '/quote-search', 
    name: 'QuoteLanding', 
    component: () => import('@/views/CustomerQuotes/QuoteLanding.vue'), 
    meta: { public: true } 
  },
  
  // NEW: Password change route
  { 
    path: '/change-password', 
    name: 'ChangePassword', 
    component: () => import('@/views/ChangePassword.vue'),
    meta: { requiresAuth: false, requiresPendingChange: true } 
  },
  
  // NEW: Admin Security Dashboard
  { 
    path: '/admin/security', 
    name: 'AdminSecurityDashboard', 
    component: () => import('@/views/Admin/AdminSecurityDashboard.vue'),
    meta: { requiresAuth: true, requiresAdmin: true } 
  },
  
  { path: '/ReportBug', name: 'ReportBug', component: ReportBug, meta: { requiresAuth: true } },
  { path: '/home', name: 'Home', component: Home, meta: { requiresAuth: true } },
  { path: '/AdminSection', name: 'AdminSection', component: AdminSection, meta: { requiresAuth: true, requiresAdmin: true } },
  { path: '/AdminPasswordReset', name: 'AdminPasswordReset', component: AdminPasswordReset, meta: { requiresAuth: true, requiresAdmin: true } },
  { path: '/Addjob', name: 'Addjob', component: Addjob, meta: { requiresAuth: true } },
  { path: '/profile', name: 'UserProfile', component: UserProfile, meta: { requiresAuth: true } },
  { path: '/Activity', name: 'Activity', component: Activity, meta: { requiresAuth: true } },
  {
    path: '/ai-agent', redirect: '/Functions', meta: { requiresAuth: true },
  },
  { path: '/ClockIn', name: 'ClockIn', component: ClockIn, meta: { requiresAuth: true } },
  { path: '/ViewJob', name: 'ViewJob', component: ViewJob, meta: { requiresAuth: true } },
  { path: '/Functions', name: 'Functions', component: Functions, meta: { requiresAuth: true } },
  // { path: '/inventory-view', name: 'InventoryView', component: InventoryView, meta: { requiresAuth: true, permission: 'inventoryView' } },
  
  // Activity Module Routes
  { path: '/activity/jobs', name: 'ActivityJobs', component: ActivityJobs, meta: { requiresAuth: true } },
  { path: '/activity/sales-order-tracker', name: 'ActivitySalesOrderTracker', component: ActivitySalesOrderTracker, meta: { requiresAuth: true } },
  
  { path: '/Returns', name: 'Returns', component: Returns, meta: { requiresAuth: true } },
  { path: '/AddReturns', name: 'AddReturns', component: AddReturns, meta: { requiresAuth: true } },
  { path: '/EditReturns', name: 'EditReturns', component: EditReturns, meta: { requiresAuth: true } },
  { path: '/PO', name: 'PO', component: PO, meta: { requiresAuth: true } },
  { path: '/AddPO', name: 'AddPO', component: AddPO, meta: { requiresAuth: true } },
  { path: '/AllPO', name: 'AllPO', component: AllPO, meta: { requiresAuth: true } },
  { path: '/EditPO', name: 'EditPO', component: EditPO, meta: { requiresAuth: true } },
  { path: '/Deliveries', name: 'Deliveries', component: Deliveries, meta: { requiresAuth: true } },
  { path: '/EditDeliveries', name: 'EditDeliveries', component: EditDeliveries, meta: { requiresAuth: true } },
  { path: '/AddDeliveries', name: 'AddDeliveries', component: AddDeliveries, meta: { requiresAuth: true } },
  { path: '/AllReturns', name: 'AllReturns', component: AllReturns, meta: { requiresAuth: true } },
  { path: '/AllJobs', name: 'AllJobs', component: AllJobs, meta: { requiresAuth: true } },
  { path: '/RequestLeave', name: 'RequestLeave', component: RequestLeave, meta: { requiresAuth: true } },
  { path: '/AllDeliveries', name: 'AllDeliveries', component: AllDeliveries, meta: { requiresAuth: true } },
  { path: '/AllReport', redirect: '/Functions' },
  { path: '/AddFailedReport', redirect: '/Functions' },
  { path: '/EditFailedReport', redirect: '/Functions' },
  { path: '/ViewFailedReport', redirect: '/Functions' },
  { path: '/EngineerVB', name: 'EngineerVB', component: EngineerVB, meta: { requiresAuth: true } },
  { path: '/SalesVB', name: 'SalesVB', component: SalesVB, meta: { requiresAuth: true } },
  { path: '/TechVB', name: 'TechVB', component: TechVB, meta: { requiresAuth: true } },
  { path: '/AddSpares', name: 'AddSpares', component: AddSpares, meta: { requiresAuth: true } },
  { path: '/EditSpares', name: 'EditSpares', component: EditSpares, meta: { requiresAuth: true } },
  { path: '/AllSpares', name: 'AllSpares', component: AllSpares, meta: { requiresAuth: true } },
  { path: '/TechAddJob', name: 'TechAddJob', component: TechAddJob, meta: { requiresAuth: true } },
  { path: '/AddQuote', name: 'AddQuote', component: AddQuote, meta: { requiresAuth: true } },
  { path: '/EditQuote', name: 'EditQuote', component: EditQuote, meta: { requiresAuth: true } },
  { path: '/AllQuote', name: 'AllQuote', component: AllQuote, meta: { requiresAuth: true } },
  { path: '/Quote', name: 'Quote', component: Quote, meta: { requiresAuth: true } },
  { path: '/AddSample', name: 'AddSample', component: AddSample, meta: { requiresAuth: true } },
  { path: '/EditSample', name: 'EditSample', component: EditSample, meta: { requiresAuth: true } },
  { path: '/AllSample', name: 'AllSample', component: AllSample, meta: { requiresAuth: true } },
  { path: '/Sample', name: 'Sample', component: Sample, meta: { requiresAuth: true } },
  { path: '/AddSalesTracker', name: 'AddSalesTracker', component: AddSalesTracker, meta: { requiresAuth: true } },
  { path: '/EditSalesTracker', name: 'EditSalesTracker', component: EditSalesTracker, meta: { requiresAuth: true } },
  { path: '/AllSalesTracker', name: 'AllSalesTracker', component: AllSalesTracker, meta: { requiresAuth: true } },
  { path: '/SalesTracker', name: 'SalesTracker', component: AllSalesTracker, meta: { requiresAuth: true } },
  { path: '/AddShipment', name: 'AddShipment', component: AddShipment, meta: { requiresAuth: true } },
  { path: '/EditShipment', name: 'EditShipment', component: EditShipment, meta: { requiresAuth: true } },
  { path: '/AllShipment', name: 'AllShipment', component: AllShipment, meta: { requiresAuth: true } },
  { path: '/AddSerialNumber', name: 'AddSerialNumber', component: AddSerialNumber, meta: { requiresAuth: true } },
  { path: '/EditSerialNumber', name: 'EditSerialNumber', component: EditSerialNumber, meta: { requiresAuth: true } },
  { path: '/AllSerialNumbers', name: 'AllSerialNumbers', component: AllSerialNumber, meta: { requiresAuth: true } },
  
  // Job Reports Routes
  { path: '/AllJobReports', redirect: '/Functions' },
  { path: '/AddJobReports', redirect: '/Functions' },
  { path: '/EditJobReports', redirect: '/Functions' },

  // Old Jobs Routes
  { path: '/OldJobs', name: 'OldJobs', component: OldJobs, meta: { requiresAuth: true } },
  { path: '/AddOldJobs', name: 'AddOldJobs', component: AddOldJobs, meta: { requiresAuth: true } },
  { path: '/EditOldJob', name: 'EditOldJob', component: EditOldJobs, meta: { requiresAuth: true } },

  { path: '/dropdown-manager', name: 'DropdownManager', component: DropdownManager, meta: { requiresAuth: true } },
  { path: '/shared-services',   name: 'SharedServices',   component: SharedServices,   meta: { requiresAuth: true } },

  { path: '/AddQuotation', name: 'AddQuotation', component: AddQuotation, meta: { requiresAuth: true } },
  { path: '/AllQuotation', name: 'AllQuotation', component: AllQuoted, meta: { requiresAuth: true } },
  
  // NEW: Updated Portal Routing for AUS
  { path: '/:quoteNumber', name: 'QuotePortal', component: () => import('@/views/CustomerQuotes/QuotePortal.vue'), meta: { public: true } },
  { path: '/aus/:quoteNumber', name: 'LegacyQuotePortal', component: () => import('@/views/CustomerQuotes/QuotePortal.vue'), meta: { public: true } },
  
  { path: '/EditQuotation/:id', name: 'EditQuotation', component: EditQuotation, props: true, meta: { requiresAuth: true } }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Enhanced Navigation Guard
router.beforeEach((to, from, next) => {

  // Route the AUS quote domain to the public quote lookup page.
  const hostname = window.location.hostname || ''
  const isQuoteDomain = hostname === 'aus.nexus-quotes.com'
  if (to.path === '/' && isQuoteDomain) {
    return next('/quote-search');
  }

  // Allow public routes through immediately
  if (to.meta.public) return next()

  const auth = getAuth()
  const currentUser = auth.currentUser
  const userRole = localStorage.getItem('role')
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
  const requiresPendingChange = to.matched.some(record => record.meta.requiresPendingChange)

  // Check for pending password change requirement
  if (requiresPendingChange) {
    const pendingChange = localStorage.getItem('pendingPasswordChange')
    if (!pendingChange) {
      return next('/')
    }
    return next()
  }

  // Check authentication
  if (requiresAuth) {
    if (!userRole || !currentUser) {
      if (to.path !== '/' && to.path !== '/login') {
        return next('/')
      }
      return next()
    }

    // Check admin access
    if (requiresAdmin) {
      const allowedRoles = ['Admin', 'Engineer', 'Salesperson', 'Technician', 'procurement', 'Debtors']
      if (!allowedRoles.includes(userRole)) {
        if (to.path !== '/' && to.path !== '/login') {
          return next('/')
        }
        return next()
      }
    }
  }

  next()
})

export default router